import { memo } from "react";
import { Grid, Box, Card, Typography } from "@mui/material";

const EcommerceSelection = ({ integrations, handleSelectNew }) => (
  <Box>
    <Typography
      variant="h6"
      sx={{ mb: 3, fontWeight: "bold", textAlign: "center" }}
    >
      Selecciona una integración
    </Typography>
    <Grid container spacing={2}>
      {integrations.map((ecommerce) => (
        <Grid
          key={ecommerce.name}
          container
          direction="row"
          spacing={1}
          sx={{
            justifyContent: "center",
            alignItems: "flex-start",
            pt: 4,
          }}
          columns={16}
        >
          <Grid size={8} sx={{ m: 2 }}>
            <Card
              key={`ecommerce-card-${ecommerce.id}`}
              onClick={(e) => handleSelectNew(ecommerce, false)}
              sx={{
                maxWidth: 400,
                borderRadius: "4px !important",
                cursor: "pointer",
                boxShadow: "0px 6px 12px rgba(0, 0, 0, 0.25)",
              }}
            >
              <img
                src={ecommerce.image}
                alt={``}
                style={{
                  width: "100%",
                  height: 100,
                  transition: "filter 0.3s ease-in-out",
                }}
              />
            </Card>
          </Grid>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default memo(EcommerceSelection);
